import type { ReactNode } from "react";
import { cn } from "./lib/utils";

/** The confirming button sits bottom-right; `leading` goes a whole row away from it. */
export function FormActions({
  leading,
  className,
  children,
}: {
  leading?: ReactNode;
  className?: string;
  children: ReactNode;
}) {
  return (
    <div className={cn("flex flex-wrap items-center justify-end gap-3", className)}>
      {leading && <div className="me-auto">{leading}</div>}
      {children}
    </div>
  );
}
